import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import SocialIcons from "./SocialIcons";
import "../css/footer.css";

const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer" id="footer">
      <div className="container">
        <h2 className="footer-title">{t.footerTitle}</h2>
        <SocialIcons className="footer-social" />
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Daniel Pereira Sanches. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
